import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Axios from 'axios'
import CKEditor from '@ckeditor/ckeditor5-vue2';
import DefaultLayout from './layouts/applicant/default-layout'
import LoginLayout from './layouts/login-layout'
import RulesLayout from './layouts/applicant/rules-layout'
import SupervisorLayout from './layouts/supervisor/supervisor-layout'
import PreviewLayout from './layouts/preview-layout'
import User from "@/components/User";
import moment from 'moment'
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

Vue.config.productionTip = false

Sentry.init({
  Vue,
  dsn: "https://8aceb85c0e0f40b08393e3be153993c4@o762934.ingest.sentry.io/5793680",
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 1.0,
});

Vue.component('default-layout', DefaultLayout);
Vue.component('loginLayout', LoginLayout);
Vue.component('rulesLayout', RulesLayout);
Vue.component('supervisorLayout', SupervisorLayout);
Vue.component('preview-layout', PreviewLayout);

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use( CKEditor );

require('moment/locale/ru');
moment.locale('ru')
Vue.prototype.moment = moment

User.initData()
Vue.prototype.$http = Axios.create({
  baseURL: process.env.VUE_APP_API_URL + '/api/exam',
  headers: {
    Authorization: 'Bearer ' + User.accessToken
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
